import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { SURFACE, TEXT_MUTED } from "./palette";

const TooltipBox = styled.div`
  background: ${SURFACE};
  border: 1px solid rgba(11, 11, 11, 0.1);
  border-radius: 6px;
  padding: 0.5em 0.75em;
  font-size: 0.85em;
`;

const TooltipLabel = styled.div`
  color: ${TEXT_MUTED};
  margin-bottom: 4px;
`;

const TooltipValue = styled.div`
  font-weight: 600;
`;

export default function ChartTooltip({ label, value, detail }) {
  return (
    <TooltipBox>
      <TooltipLabel>{label}</TooltipLabel>
      <TooltipValue>{value}</TooltipValue>
      {detail && <TooltipLabel as="div">{detail}</TooltipLabel>}
    </TooltipBox>
  );
}

ChartTooltip.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  detail: PropTypes.string,
};

ChartTooltip.defaultProps = {
  detail: null,
};
